(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/behaviors/payfooter.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/behaviors/payfooter.js');

'use strict';

svs.numbergames.game.behaviors.Payfooter = Marionette.Behavior.extend({
  options() {
    return {
      shouldShowSum: () => {},
      payButtonTitle: () => 'Betala {amount} kr',
      payButtonTitleDisabled: () => 'Betala',
      payButtonCallback: () => this.view.triggerMethod('pay'),
      payfooterBalanceText: () => {},
      payfooterSumText: () => 'Summa: {amount} kr',
      payfooterTexts: () => [],
      reminderOptions: () => ({
        trackingLabel: svs.numbergames.productMapping.getProductName(this.model.get('productId'))
      })
    };
  },
  modelEvents: {
    'change:price': 'changedPrice',
    'change:isValid': 'changedIsValid'
  },
  behaviors() {
    const behaviorArray = [{
      behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
      channel: svs.numbergames.game.huxfluxRadio,
      context: this
    }];
    if (this.getOption('analyticsEvents')) {
      behaviorArray.push({
        behaviorClass: svs.numbergames.game.behaviors.PayfooterAnalytics,
        analyticsEvents: this.getOption('analyticsEvents')
      });
    }
    return behaviorArray;
  },
  radioEvents: {
    'huxflux:start': 'onHuxfluxStarted',
    'huxflux:end': 'onHuxfluxEnded',
    'package:huxflux:started': 'onHuxfluxStarted',
    'package:huxflux:ended': 'onHuxfluxEnded'
  },
  initialize() {
    this.mergeOptions(this.view.options, ['model']);
    this.view.template = () => this.payfooter.render();
    this.listenTo(this.model.get('tickets'), 'change', this.changedPrice);
  },
  onInitialize() {
    this.createPayfooter();
  },
  onRender() {
    this.view.triggerMethod('updatePayButtonState');
  },
  onAttach() {
    this.view.triggerMethod('updateReminderState');
  },
  createPayfooter() {
    const payButton = new svs.tur.payfooter.button.Primary({
      title: this.options.payButtonTitle(),
      titleDisabled: this.options.payButtonTitleDisabled(),
      callback: _.debounce(this.options.payButtonCallback, 300, true),
      autoUpdateState: false
    });
    const balance = new svs.tur.payfooter.text.Balance({
      text: this.options.payfooterBalanceText()
    });
    const payfooterOptions = {
      balance,
      buttons: [payButton],
      text: this.options.payfooterTexts(),
      reminderOptions: this.options.reminderOptions(),
      calculateParentElements: svs.tur.payfooter.PARENT_ELEMENTS
    };
    if (this.options.shouldShowSum()) {
      payfooterOptions.sum = new svs.tur.payfooter.text.Sum({
        text: this.options.payfooterSumText(),
        amount: this.getPrice()
      });
    }
    this.payButton = payButton;
    this.payfooter = new svs.tur.payfooter.Default(payfooterOptions);
    this.view.triggerMethod('payfooterCreated');
  },
  changedIsValid() {
    this.view.triggerMethod('updatePayButtonState');
  },
  changedPrice() {
    this.view.triggerMethod('updatePayfooterSum');
    this.view.triggerMethod('updateReminderState');
  },
  getPrice() {
    let price = this.model.get('price');
    if (price > 0) {
      price += this.model.get('tickets').calculatePrice();
    }
    return price;
  },
  onUpdatePayButtonState() {
    if (this.model.get('isValid')) {
      this.payButton.enable();
    } else {
      this.payButton.disable();
    }
  },
  onUpdateReminderState() {
    if (this.model.get('isValid') && this.model.get('price')) {
      this.payfooter.showReminder();
    } else {
      this.payfooter.hideReminder();
    }
  },
  onUpdatePayButtonTitle() {
    var _svs$tur$ab_tests;
    if (((_svs$tur$ab_tests = svs.tur.ab_tests) === null || _svs$tur$ab_tests === void 0 ? void 0 : _svs$tur$ab_tests.data.PayfooterReminder) === 'B') {
      this.payfooter.updateReminderButtonTitle(this.options.payButtonTitle());
    }
    this.payButton.amount.updateTitle(this.options.payButtonTitle());
  },
  onUpdatePayfooterSum() {
    this.payfooter.updateSum({
      text: this.options.payfooterSumText(),
      amount: this.getPrice()
    });
  },
  onUpdatePayfooterBalance(amount) {
    this.payfooter.updateBalance({
      text: this.options.payfooterBalanceText(),
      amount,
      forceDim: !this.getPrice()
    });
  },
  onUpdatePayfooterText() {
    this.payfooter.updateText({
      text: this.options.payfooterTexts()
    });
  },
  onHuxfluxStarted() {
    this.payButton.disable();
  },
  onHuxfluxEnded() {
    this.model.get('isValid') && this.payButton.enable();
  },
  onDestroy() {
    var _svs$tur$ab_tests2;
    this.payfooter.hideReminder();
    if (((_svs$tur$ab_tests2 = svs.tur.ab_tests) === null || _svs$tur$ab_tests2 === void 0 ? void 0 : _svs$tur$ab_tests2.data.PayfooterReminder) === 'B') {
      this.payfooter.destroyReminder();
    }
  }
});

 })(window);